import { TranslationsContext } from '@teliaee/telia-translate';
import React from 'react';
import { Grid, GridColumn } from 'telia-front-react';
import { observer } from 'mobx-react';
import { useStores } from '../stores/RootStore';
import ReservationForm from './ReservationForm';
import ReservationSuccess from './ReservationSuccess';
import ReservationPreview from './ReservationPreview';

const Reservation = observer((): React.JSX.Element => {
  const {
    reservationStore: { fetchBranchList, setInitialValuesOfBranchAndTimeAndAvailableReservations, reservationCreationState }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  React.useEffect(() => {
    fetchAndInitialize();
  }, []);

  const fetchAndInitialize = async () => {
    await fetchBranchList();
    await setInitialValuesOfBranchAndTimeAndAvailableReservations(translate);
  };

  const renderStep = (): React.JSX.Element => {
    if (['SUCCESS'].includes(reservationCreationState.status)) {
      return <ReservationSuccess />;
    }

    if (['BEING_FILLED', 'ERROR', 'INVALID_INPUT', 'VALIDATION_FAILED'].includes(reservationCreationState.status)) {
      return <ReservationForm />;
    }

    return <ReservationPreview />;
  };

  return (
    <Grid>
      <GridColumn width={['xs-12', 'md-10', 'lg-8', 'xl-6']}>{renderStep()}</GridColumn>
    </Grid>
  );
});

export default Reservation;
